import { faBallot, faCloudUpload, faCode } from '@fortawesome/pro-light-svg-icons';
import { faUser, faUsers } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { NavItem } from '@feathr/components';
import { useAccount, useLocalUrl, useUser } from '@feathr/extender/state';

import SecondaryNav from '../SecondaryNav';
import TertiaryNav from '../TertiaryNav';

function DataNav(): JSX.Element {
  const account = useAccount();
  const localUrl = useLocalUrl();
  const user = useUser();
  const { pathname } = useLocation<{ pathname: string }>();
  const { t } = useTranslation();

  const secondary = pathname.split('/')[3];

  return (
    <SecondaryNav label={t('Community navigation')}>
      <NavItem icon={faUser} to={localUrl('/data/explore')}>
        {t('People')}
      </NavItem>
      {secondary === 'explore' && (
        <NavItem>
          <TertiaryNav label={t('Important groups of people navigation')}>
            <NavItem to={localUrl('/data/explore/all/people')}>{t('All')}</NavItem>
            <NavItem to={localUrl('/data/explore/known/people')}>{t('Known')}</NavItem>
            <NavItem to={localUrl('/data/explore/anonymous/people')}>{t('Anonymous')}</NavItem>
          </TertiaryNav>
        </NavItem>
      )}
      <NavItem icon={faUsers} to={localUrl('/data/segments')}>
        {t('Groups')}
      </NavItem>
      {account.isFalcon && (
        <NavItem icon={faBallot} to={localUrl('/data/custom-fields')}>
          {t('Custom Fields')}
        </NavItem>
      )}
      <NavItem icon={faCloudUpload} to={localUrl('/data/imports')}>
        {t('Imports')}
      </NavItem>
      <NavItem icon={faCode} to={localUrl('/data/pixel')}>
        {t('Super Pixel')}
      </NavItem>
      {secondary === 'pixel' && (
        <NavItem>
          <TertiaryNav label={t('Implementation navigation')}>
            <NavItem to={localUrl('/data/pixel/conversions')}>{t('Conversion Pixels')}</NavItem>
            {(account.hasPixelImplementation || user.isSudoer) && (
              <NavItem to={localUrl(`/data/pixel/implementations`)}>{t('Implementations')}</NavItem>
            )}
          </TertiaryNav>
        </NavItem>
      )}
    </SecondaryNav>
  );
}

export default DataNav;
